import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPlus$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPlus extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'c4940ff7f9dc2e606bdfa79a9bfd74c141d34c5a', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '95994b60ab74a6bcc806e040879f41d8b3d21d51', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '5e112ba5c6e7c9195b08235ed52228971f9e5932', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M17 10.25h-5.25V5a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v5.25H5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h5.25V17a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-5.25H17a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-plus", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-plus"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-plus":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPlus$1);
            }
            break;
    } });
}

const CosmosIconPlus = CosmosIconPlus$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPlus, defineCustomElement };
